function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "jquery",
  d: "M433.7,338.9l-2,5.1c-33.4,65.1-92.7,105-177.1,106.8c-39.5,0.8-77.1-9.3-101.7-20.3 c-53-23.8-97.7-68-122-115.3c-35-67.7-41.3-161.9,31.4-232.2c1.1,0-8.8,15.3-7.7,15.3l-2,6.5c-52.4,164,109,304.5,265.8,288.4 C356.2,389.2,404.2,368.6,433.7,338.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "jquery",
  d: "M338.8,271c39.5,0.3,80.7-18.2,105.1-44.1c-21.4,54.2-83.2,89.1-166.1,78c-69.4-9.3-135.6-79.2-142.4-149.2 c-5-50.9,12.8-81.4,42-118.2c-10.2,19.3-14,34.2-14.9,43.7C151.4,191.4,250.6,270.5,338.8,271"
}), /*#__PURE__*/React.createElement("path", {
  className: "jquery",
  d: "M439.9,134.2c-6.1,14.1-41.5,40.6-57.1,44c-61.8,13.2-101.3-16.1-122-49.5c-3.1-5-8.8-18.6-9.8-22 c-8-27.3-4.3-68.7,19.6-90c-7.2,20.3-8.3,44-4.5,59.3c2.3,9.3,9.3,25.5,16.3,35.7c12.8,18.6,20.9,23.1,37.3,33 c7.4,4.4,15.3,8,18.7,9C354.1,158.1,387,170.2,439.9,134.2"
})));

function SvgJquery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 456.1 465.7",
    style: {
      enableBackground: "new 0 0 456.1 465.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJquery);
export default __webpack_public_path__ + "static/media/jquery.a037b400.svg";
export { ForwardRef as ReactComponent };